<template>
	<section class="vx-row justify-center w-full py-6 md:py-12 lg:py-24 mb-24 mx-1">
		<div class="vx-col w-full md:w-full lg:w-5/6 xl:w-2/3">
			<vx-card>
				<div class="flex mb-8">
					<router-link :to="`/qurban/choose-payment/${$route.params.slug_and_id}`">
						<feather-icon icon="ChevronLeftIcon" svgClasses="text-primary mr-4"></feather-icon>
					</router-link>
					<strong class="text-primary"><small>Konfirmasi Pembayaran</small></strong>
				</div>

                <div class="flex justify-center item-start mb-12">
					<img src="/assets/images/topup/confirm.svg" alt="" class="md:w-1/4 w-1/6" />
				</div>
				<section class="vx-row justify-center mb-4">
					<div class="vx-col lg:w-5/6 xl:w-2/3">
						<table class="w-full">
							<tr style="vertical-align: top;">
								<td class="text-left">
									<strong class="text-dark">Lembaga Penyaluran</strong>
								</td>
								<td class="text-right">
									<strong class="text-grey">{{ (transactionProduct && transactionProduct.mt) ? (transactionProduct.mt.user ? transactionProduct.mt.user.name : '-') : '-' }}</strong>
								</td>
							</tr>
							<tr style="vertical-align: top;">
								<td class="text-left">
									<strong class="text-dark">Qurban</strong>
								</td>
								<td class="text-right">
									<strong class="text-grey">{{ transactionProduct ? transactionProduct.name : '-' }}</strong>
								</td>
							</tr>
						</table>
						<vs-divider class="my-4"></vs-divider>
						<table class="w-full">
							<tr style="vertical-align: top;">
								<td class="text-left">
									<strong class="text-dark">Metode Pembayaran</strong>
								</td>
								<td class="text-right">
									<strong class="text-grey">{{ transactionPayment ? transactionPayment.name : '-' }}</strong>
								</td>
							</tr>
							<tr>
								<td class="text-left">
									<strong class="text-dark">Jumlah Mudhohi</strong>
								</td>
								<td class="text-right">
									<strong class="text-grey">{{ transactionProduct && transactionProduct.mudhohis ? transactionProduct.mudhohis.length : 0 }} orang</strong>
								</td>
							</tr>
							<tr v-if="transactionProduct.mudhohis.length">
								<td>
									<ol>
										<li 
											v-for="(item, i) in transactionProduct.mudhohis"
											:key="i"
										>
											{{ item.value }}
										</li>
									</ol>
								</td>
							</tr>
						</table>
						<vs-divider class="my-4"></vs-divider>
						<table class="w-full">
							<tr style="vertical-align: top;">
								<td class="text-left">
									<strong class="text-dark">Total Pembayaran</strong>
								</td>
								<td class="text-right">
									<strong class="text-dark">Rp {{ (transactionProduct.price == 0 ? 0 : formatRupiah(transactionProduct.price)) }}</strong>
								</td>
							</tr>
						</table>
					</div>
				</section>

				<!-- Detail Name -->
				<section class="md:p-12 mb-12">

					<vs-collapse v-if="profile">
						<vs-collapse-item>
							<div slot="header">
							<small>Info Donatur (opsional)</small>
							</div>
							<form>
							<p class="mb-2"><strong>Email</strong></p>
							<vs-input 
								class="w-full rounded-lg mb-4"
								v-model="email"
							/>
							<p class="mb-2"><strong>No. Telepon</strong></p>
							<vs-input 
								class="w-full rounded-lg mb-4"
								v-model="no_telp"
							/>
							</form>
						</vs-collapse-item>
					</vs-collapse>
					<form v-else>
						<p class="mb-2"><strong>Email</strong></p>
						<vs-input
							class="w-full rounded-lg mb-4"
							v-model="email"
							name="email"
							v-validate="'required|email'"
							:danger="errors.has('email')"
						/>
						<span v-if="errors.has('email')" class="text-small text-danger">
							{{ errors.first('email') }}
						</span>
						<p class="mb-2"><strong>No. Telepon</strong></p>
						<vs-input
							type="number"
							class="w-full rounded-lg mb-4"
							v-model="no_telp"
							name="no_telp"
							v-validate="'required|min:10|max:13'"
							:danger="errors.has('no_telp')"
						/>
						<span v-if="errors.has('no_telp')" class="text-small text-danger">
							{{ errors.first('no_telp') }}
						</span>
					</form>
					<!-- / -->
				</section>

				<vs-button class="py-4 w-full" @click.prevent="validateTransaction">
					<strong class="text-white">Bayar</strong>
				</vs-button>
            </vx-card>
        </div>
    </section>
</template>
<script>
    import { mapState } from 'vuex';
	import { Validator } from 'vee-validate';

	const dict = {
		custom: {
			email: {
				required: 'Harap isi alamat email anda',
				email: 'Harap masukan email  yang valid'
			},
			no_telp: {
				required: 'Harap masukan nomer telepon anda',
				min: 'Nomer telepon minimal 10 digit',
				max: 'Nomer telepon maksimal 13 digit'
			}
		}
	};

	Validator.localize('en', dict);
	
    export default {
        data: () => ({
            jenis: [],
			payload: {},
			data: {id: 0},
			name: null,
			email: null,
			no_telp: null
        }),
        computed: {
            ...mapState('qurban', ['transactionProduct', 'transactionPayment', 'transactionTypes']),
			...mapState('auth', ['profile'])
        },
        methods: {
			getQurban() {
				// get id from slug
				const arrSlug = this.$route.params.slug_and_id.split('-'),
						id = Buffer.from(arrSlug[ arrSlug.length - 1 ], 'base64').toString();

				// Check if exist in state
				this.$store.dispatch('qurban/getDetail', id)
				.then(qurban => {
					if(!qurban.donatur_doa) {
						qurban.donatur_doa = [];
					}
					Object.assign(this.data, qurban);
					this.data.deskripsi = this.replaceText(this.data.deskripsi);
					
					this.data.file_user_url = null;
					if(this.data.user && this.data.user.file !== null) {
						this.data.file_user_url = process.env.VUE_APP_STORAGE + '/' + this.data.user.file;
					}
				})
				.catch(e => {
					console.error(e);
					// this.$router.push('/404-notfound')

					return false;
				});
			},
            getTypeTransaction () {
                this.$vs.loading()
                this.$store.dispatch('transaction/getTypeTransaction')
                .then(types => {
                    this.$vs.loading.close()
                    this.jenis = types
                })
                .catch(e => {
                    this.$vs.loading.close()
                    console.error(e)	
                    if (e.response) {
                        console.error(e.response)
                    }

                    return false
                })
            },
			validateTransaction() {
				if(this.profile) {
					this.postTransaction();
				}
				else {
					this.$validator.validateAll().then(res => {
						if(res) {
							this.postTransaction();
						}
					});
				}
			},
            postTransaction() {
                
				let jenis_id = 1;
				if(this.jenis.length > 0) {
					const jenis = this.jenis.find(it => it.name.toLowerCase() == 'qurban');

					if(jenis) {
						jenis_id = jenis.id;
					}
				}
				const success_url = process.env.VUE_APP_FE ? process.env.VUE_APP_FE : 'https://zax.co.id',
            		failed_url = process.env.VUE_APP_FE ? process.env.VUE_APP_FE : 'https://zax.co.id';

				const arrSlug = this.$route.params.slug_and_id.split('-'),
                    id = Buffer.from(arrSlug[ arrSlug.length - 1 ], 'base64').toString();

				const mudhohis = this.transactionProduct.mudhohis.length ? this.transactionProduct.mudhohis.map(item => item.value).join(',') : null;
				if(this.profile) {
					this.payload = {
						user_id: this.profile.id,
						metode_id: this.transactionPayment.id,
						jenis_id,
						fitur_id: id,
						jumlah_bayar: this.transactionProduct.nominal,
						success_url,
						failed_url,
						name: mudhohis,
						email: this.email,
						no_telp: this.no_telp,
						doa: null
					};
				}
				else {
					this.payload = {
						metode_id: this.transactionPayment.id,
						jenis_id,
						fitur_id: id,
						jumlah_bayar: this.transactionProduct.nominal,
						success_url,
						failed_url,
						name: mudhohis,
						email: this.email,
						no_telp: this.no_telp,
						doa: this.doa
					};
				}

				if(this.transactionProduct.mt && this.transactionProduct.mt.id) {
					this.payload.mitra_id = this.transactionProduct.mt.id;
				}

				if(this.$route.query.ref) {
					this.payload.referal = this.$route.query.ref;
				}

				this.$vs.loading();
				this.$store.dispatch('qurban/makeTransaction', [ this.payload ])
				.then(() => {
					this.$vs.loading.close();
					const history = this.$store.state.qurban.transactionHistory;
					if( history && history.metode_pembayaran ) {
						// Delete state payment and product
						this.$store.dispatch('qurban/removeTransactionProduct');
						this.$store.dispatch('qurban/removeTransactionPayment');
						this.$store.dispatch('transaction/removeTransactionTypes');
					}

					this.$router.push(`/qurban/niat/${this.$route.params.slug_and_id}`)
				})
				.catch(e => {
					this.$vs.loading.close();
					if (e.response) {
						console.error(e.response);
						this.$vs.notify({
							title: 'Oops',
							text: e.response.data.message,
							color: 'warning',
							position: 'top-right'
						});
					}

					return false;
				});
            }
        },
        created() {
			this.getQurban();
            this.checkVerifyAccount();
            if(!this.transactionProduct || !this.transactionPayment) {
                this.$router.push('/home');
            }
            this.getTypeTransaction();
        }
    }
</script>